<template>
  <div class="device-type app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>类型名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入类型名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
	  
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>类型编码</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入类型编码" v-model="table.search.type_code"></a-input>
          </a-col>
        </a-row>
      </a-col>
	  
	  <a-col :span="24" :xl="8">
	    <a-row :gutter="[8, 8]">
	      <a-col>
	        <p>类型备注</p>
	      </a-col>
	      <a-col>
	        <a-input placeholder="请输入类型备注" v-model="table.search.remark"></a-input>
	      </a-col>
	    </a-row>
	  </a-col>
	  
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
		  <a-button type="primary" @click="newType()">添加类型</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <!-- 操作 -->
	  <template slot="action" slot-scope="text, data">
        <a-space>
		  <a-button type="link" @click="editType(data)">编辑</a-button>
		  <a-button type="link" @click="deleteType(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
	
  import DeviceType from '@/io/device_type.js';
	
  export default {
    data() {
      let self = this;
      return {
        table: {
          loading: false,
		  //这是搜索框的数据
          search: {
            name: null,
			type_code:null,
			remark:null,
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
		  //表格内的数据
          data: [],
          columns: [
            {
              title: '类型名称',
              dataIndex: 'name'
            },
            {
              title: '类型编码',
              dataIndex: 'type_code'
            },
            {
              title: '类型备注',
              dataIndex: 'remark'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    activated() {
      this.initData();
    },
    methods: {
		
	  
	  
	  //新增
	  newType() {
	    this.table.page.current = 1;
			this.$router.push({
				name:'NewType'
			});
	  },
		//编辑
		editType(data) {
		  this.$router.push({
				name:'EditType',
				params: {
				  id: data.id
				},
			});
		},
		
		//删除
		deleteType(data) {
		  let self = this;
		  this.$confirm({
		    title: '提示',
		    content: '确认删除此类型？',
		    onOk() {
		      DeviceType.del(data.id).then(res => {
		        self.initData();
		      }).catch(err => {});
		    }
		  });
		},
	  //搜索表格，需要将表格的参数绑定
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
		//这里是表格内绑定的参数，数据类型不要出错
      resetSearchTable() {
        this.table.search = {
          name: null,
          type_code: null,
          remark: null,
        };
        this.searchTable();
      },
	  //这是分页
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
			//显示数据
      initData() {
        this.table.loading = true;
        return DeviceType.listPage(
          this.table.search.name,
          this.table.search.type_code,
          this.table.search.remark,
          this.table.page.current,
          this.table.page.pageSize,
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>